// Predefined device constants for consistency across the app
export const PREDEFINED_DEVICE_NAMES = [
  // General Lighting
  'Ceiling Light',
  'Chandelier',
  'Spot Light',
  'Cove Light',
  'Wall Light',

  // Curtains & Windows
  'Curtain',
  'Curtain Spot Light',

  // Bedroom Specific
  'Bedside Light',
  'Headboard Cove Light',
  'Wardrobe Light',
  'Mirror Light',

  // Kitchen
  'Kitchen Counter Light',
  'Under Cabinet Light',

  // Bathroom
  'Bathroom Ceiling Light',
  'Shower Light',

  // Vertical / Circulation
  'Staircase Ceiling Light',
  'Staircase Step Light',

  // Outdoor / Utility
  'Garage Light',
  'Courtyard Light',
  'Terrace Light',
  'Garden Light',
  'Driveway Light',
  'Main Gate Light',

  // Climate / Sensors
  'Thermostat',
  'Presence Sensor',
  'Motion Sensor'
];

export const PREDEFINED_LOCATIONS = [
  'Entrance',
  'Hallway',
  'Living Room',
  'Dining',
  'Kitchen',
  'Master Bedroom',
  'Bedroom 1',
  'Bedroom 2',
  'Guest Bedroom',
  'Bathroom',
  'Guest Bathroom',
  'Powder Room',
  'Staircase',
  'Garage',
  'Courtyard',
  'Terrace',
  'Garden',
  'Driveway',
  'Balcony',
  'Main Gate'
];

export const PREDEFINED_FLOORS = [
  'Ground Floor',
  'First Floor',
  'Second Floor',
  'Top Floor',
  'Outdoor',
  'NA'
];

export const PREDEFINED_DEVICE_TYPES = [
  'sensor',
  'thermostat',
  'curtain',
  'switch',
  'light',
  'lock'
];
